<template>
<PrimeBreadcrumb  :home="home" :model="items" style="margin-top: 0px;"></PrimeBreadcrumb>
<!--DataGrid -->
<button type="button" class="btn btn-danger" @click="add" ref="new">
          <font-awesome-icon icon="plus" />New
        </button>
  <div class="card">
    <PrimeDataTable
      ref="dt"
      :value="data"
      :paginator="true"
      :rows="10"
      dataKey="pkey"
    >
      
      <PrimeColumn :exportable="false" style="width: 6rem">
        <template #body="slotProps">
          <div class="btn-group" role="group">
            <button class="btn btn-success" @click="edit(slotProps.data)" :disabled="slotProps.data.lstHCTedelno_CustHaveUsed?.length>0">
               <font-awesome-icon icon="edit" />
            </button>
            <button
              class="btn btn-outline-success"
              @click="confirmDelete(slotProps.data)" :disabled="slotProps.data.lstHCTedelno_CustHaveUsed?.length>0"
            >
              <font-awesome-icon icon="trash" />
            </button>
          </div>
        </template>
      </PrimeColumn>
 
<PrimeColumn field="custNo" header="客戶編號" :sortable="true"></PrimeColumn>
<PrimeColumn field="custName" header="客戶名稱" :sortable="true"></PrimeColumn>

<PrimeColumn field="year" header="年度" :sortable="true"></PrimeColumn>
<PrimeColumn field="requestCount" header="預取數量" :sortable="true"></PrimeColumn>
   
<PrimeColumn header="使用率">
      <template #body="slotProps">
        {{}}
          <span>{{Number((slotProps.data.lstHCTedelno_CustHaveUsed?.length / (slotProps.data.requestCount))*100).toFixed(2)}}%</span>
      </template>
</PrimeColumn>
<PrimeColumn header="客戶預取號">
      <template #body="slotProps">
          
        <span>
            <PrimeButton
          label="區間號狀況"
          icon="pi pi-check"
          class="p-button-primary"
          @click="open2(slotProps.data.pkey)"
        />
         </span>
       
      </template>
</PrimeColumn>
     
    </PrimeDataTable>
  </div>


 <!--Edit Modal -->
  <PrimeDialog
    v-model:visible="isShowDialog"
    :style="{ width: '950px' }"
    header="客戶預取號維護"
    :modal="true"
    class="p-fluid"
  >
    <component
      :is="component_name"
      :item="item"
      @save="detailSave"
      @close="detailClose"
    ></component>
  </PrimeDialog>

  <!--Edit Modal -->
  <PrimeDialog
    v-model:visible="isShowDialog2"
    :style="{ width: '950px' }"
    header="區間號使用狀況"
    :modal="true"
    class="p-fluid"
  >
    <component
      :is="component_name2"
      :parentpkey="parentpkey"
      :custparentpkey="custparentpkey"
     ></component>
  </PrimeDialog>

  <PrimeConfirmDialog></PrimeConfirmDialog>

</template>

<script>
import service from "../service/Appservice";
export default {
   props: ["parentpkey","minno","maxno"],
  
  data() {
    return {
      isAddNew: false,
      component_name: "my-modal-agent-cust-hctedelno-range",
       component_name2: "my-hctedelno",

      item: null,
      selectedItems: null,
      data: null,
      isShowDialog: false,
      isShowDialog2: false,
      keyField: "pkey",
      custparentpkey: null,


            home: {icon: 'pi pi-home', to: '/'},
            items: [
                {label: '代理'} ,
                {label: '代理維護'} ,
                {label: '代理區間號'} ,
                {label: '代理區間號維護'} ,
                {label: '客戶預取號'} 
            ]

    };
  },
  computed: {
   
   user() {
     return this.$store.state.user;
    },
     clientId() {
     return this.$store.state.user?.clientId;
    },
     
  },
  service: null,
  created() {
    this.service = new service();
  },
  mounted() {
    this.search();
  },
  methods: {
   /////對話視窗回復事件/////////////////////////////////
    detailSave: function (obj) {
      this.isShowDialog = false;
      if (this.isAddNew) {
        this.array_addItem(this.data, obj);
      } else {
        this.array_updateItem(this.data, obj, this.keyField);
      }
    },

    detailClose: function () {
      this.isShowDialog = false;
    },
    
     open2(pkey) {
      this.custparentpkey=pkey;
      this.isShowDialog2 = true;
    },
    ////////搜尋/////////////////////////////////////
    search() {
      this.service
        .getAgentCustHCTedelnoRange(this.parentpkey)
        .then((data) => {
          console.log(data)
          this.data = [...data];
        });
    },
    //////新增,修改,刪除////////////////////////////////////////////
    add() {
       this.isAddNew=true;
       this.item={};
       this.item.parentpkey=this.parentpkey;
       this.isShowDialog = true;
    },
    edit(rowSelect) {
      this.isAddNew=false;
      console.log('edit')
      console.log(rowSelect)
      this.item=rowSelect;
      this.isShowDialog = true;
    },
    confirmDelete(selectItem) {


        var yes = confirm('你確定要刪除?');

        if (yes) {
            console.log(selectItem);
            this.delete(selectItem);
        } 

      /*   this.$confirm.require({
        message: `你確定要刪除?`,
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          //callback to execute when user confirms the action
         // this.delete(selectItem);
          console.log(selectItem);
          console.log("confirmDelete accept");
          this.$refs['new'].focus()
        },
        reject: () => {
          //callback to execute when user rejects the action
          console.log("confirmDelete reject");
        },
      }); */
    },
    delete(selectItem) {
      var self = this;
      this.service
        .deleteAgentCustHCTedelnoRange(selectItem)
        .then(() => {
          this.array_deleteItem(self.data, selectItem, self.keyField);
        });
    },
  }
}
</script>
 